import React from "react";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
// import InputLabel from "@material-ui/core/InputLabel";
// core components
import GridItem from "components/Grid/GridItem.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
// import Button from "components/CustomButtons/Button.jsx";
import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
// import CardAvatar from "components/Card/CardAvatar.jsx";
import CardBody from "components/Card/CardBody.jsx";
import Icon from "@material-ui/core/Icon";
// core components
import CustomTabs from "components/CustomTabs/CustomTabs.jsx";
import MaterialTable from "material-table";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import { FormGroup, Label, Input } from "reactstrap";
import { Button } from "reactstrap";
import axios from "axios";
import conf from "../../conf.json";

const styles = {
  cardCategoryWhite: {
    color: "rgba(255,255,255,.62)",
    margin: "0",
    fontSize: "14px",
    marginTop: "0",
    marginBottom: "0"
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none"
  }
};

class WebView extends React.Component {
  constructor(props) {
    super(props);
    this.handleSelectSale = this.handleSelectSale.bind(this);
    this.state = {
      sales: [],
      selectsale: "",
      data: []
    };

   
  }
  componentDidMount() {
    this.getSale();
    this.getContactMunkong();
  }
  getContactMunkong() {
    this.setState({
      Loading: true
    });
    axios
      .get(conf.url + "/contact/get/" + this.props.match.params.id, {
        headers: {
          "Content-Type": "application/json"
        }
      })
      .then(res => {
       // console.log(res.data.data[0]);
        this.setState({
          data: res.data.data[0]
        });
      });
  }
  handleSelectSale = event => {
    this.setState({
      [event.target.name]: event.target.value
    });
  };
  getSale() {
    axios
      .get(conf.url + "/sale", {
        headers: {
          "Content-Type": "application/json"
        }
      })
      .then(res => {
      //  console.log(res.data.data);
        let sales = res.data.data.map((data, index) => {
          return (
            <MenuItem key={index} value={data.acusername}>
              {data.acfirstname + " " + data.aclastname}
            </MenuItem>
          );
        });
        this.setState({
          sales: sales
        });
      });
  }
  render() {
    const { classes } = this.props;
    return (
      <div>
        
        <GridContainer>
          <GridItem xs={12} sm={12} md={12}>
            <Card>
              <CardHeader color="primary">
                <h4 className={classes.cardTitleWhite}>ข้อมูลลูกค้า</h4>
              </CardHeader>
              <CardBody>
                <GridContainer>
                  <GridItem xs={12} sm={12} md={12}>
                    <CustomInput
                      labelText={
                        "ชื่อบริษัท : " +
                        (this.state.data.company_thname === undefined
                          ? "-"
                          : this.state.data.company_thname)
                      }
                      id="companyname"
                      formControlProps={{
                        fullWidth: true
                      }}
                      inputProps={{
                        disabled: true
                      }}
                    />
                  </GridItem>
                  <GridItem xs={12} sm={12} md={12}>
                    <CustomInput
                      labelText={
                        "ชื่อลูกค้า : " +
                        (this.state.data.company_thname === undefined
                          ? "-"
                          : this.state.data.contact_name)
                      }
                      id="empname"
                      formControlProps={{
                        fullWidth: true
                      }}
                      inputProps={{
                        disabled: true
                      }}
                    />
                  </GridItem>
                  <GridItem xs={12} sm={12} md={12}>
                    <CustomInput
                      labelText={
                        "เบอร์โทร : " +
                        (this.state.data.contact_no === undefined
                          ? "-"
                          : this.state.data.contact_no)
                      }
                      id="tel"
                      formControlProps={{
                        fullWidth: true
                      }}
                      inputProps={{
                        disabled: true
                      }}
                    />
                  </GridItem>
                </GridContainer>
                <GridContainer>
                  <GridItem xs={12} sm={12} md={12}>
                    <CustomInput
                      labelText={
                        "อีเมล์ : " +
                        (this.state.data.contact_email === undefined
                          ? "-"
                          : this.state.data.contact_email)
                      }
                      id="email"
                      formControlProps={{
                        fullWidth: true
                      }}
                      inputProps={{
                        disabled: true
                      }}
                    />
                  </GridItem>
                  <GridItem xs={12} sm={12} md={12}>
                    <CustomInput
                      labelText={
                        "โน้ต : " +
                        (new Date(this.state.data.sale_noted_date) >
                        new Date(this.state.data.call_center_note_date)
                          ? this.state.data.sale_noted
                          : this.state.data.call_center_noted)
                      }
                      id="note"
                      formControlProps={{
                        fullWidth: true
                      }}
                      inputProps={{
                        disabled: true
                      }}
                    />
                  </GridItem>
                </GridContainer>
                <GridContainer>
                  <GridItem xs={12} sm={12} md={12}>
                    <CustomInput
                      labelText={"มีการเปลี่ยนสถานะเป็น : " + this.state.data.status}
                      id="changestatus"
                      formControlProps={{
                        fullWidth: true
                      }}
                      inputProps={{
                        disabled: true
                      }}
                    />
                  </GridItem>
                </GridContainer>
                <GridContainer>
                  <GridItem xs={12} sm={12} md={12}>
                    {this.state.data.sales_id === null || this.state.data.sales_id === ""? <FormGroup tag="fieldset">
                      <legend>มอบหมายให้ฝ่ายขาย</legend>
                      <div className="row ml-auto mr-auto justify-content-end">
                        <div className="col-xs-12 col-sm-12 col-md-12 mb-12">
                          <FormControl
                            fullWidth
                            className={classes.selectFormControl}
                          >
                            <InputLabel
                              htmlFor="simple-select"
                              className={classes.selectLabel}
                            >
                              เลือกฝ่ายขาย
                            </InputLabel>
                            <Select
                              MenuProps={{
                                className: classes.selectMenu
                              }}
                              classes={{
                                select: classes.select
                              }}
                              value={this.state.selectsale}
                              onChange={this.handleSelectSale}
                              inputProps={{
                                name: "selectsale",
                                id: "selectsale"
                              }}
                            >
                              {this.state.sales}
                            </Select>
                          </FormControl>
                        </div>
                      </div>
                      <br />
                      <FormGroup className="text-center">
                        <Button className="btn-block" color="success"  disabled={this.state.selectsale!==""?false :true }>
                           
                          <Icon className="pt-1 mr-1">send</Icon>
                          มอบหมายให้ฝ่ายขาย
                        </Button>{" "}
                      </FormGroup>
                      {/* <FormGroup className="text-center">
                        <Button className="btn-block" color="info">
                          <Icon className="pt-1 mr-1">email</Icon>ส่งเมล์
                        </Button>{" "}
                      </FormGroup> */}
                    </FormGroup> :
                    <div style={{ border: "1px solid black" }}>
                    <FormGroup check>
                      <Label check>
                        <div className="mt-2 ml-2">
                          <h6>มอบหมายให้ฝ่ายขาย:</h6> <br />
                         {this.state.data.sale_name} เรียบร้อยแล้ว
                        </div>
                      </Label>
                    </FormGroup>
                  </div>
                  }

                    
                  </GridItem>
                </GridContainer>
              </CardBody>
            </Card>
          </GridItem>
        </GridContainer>
      </div>
    );
  }
}

export default withStyles(styles)(WebView);



// WEBPACK FOOTER //
// ./src/views/WebView/Webview.jsx